import { motion } from "framer-motion";

const AREAS = [
  {
    n: "01",
    title: "Fashion AI",
    body: "Generative tooling, design intelligence, and merchandising copilots.",
    img: "https://images.unsplash.com/photo-1509631179647-0177331693ae?auto=format&fit=crop&w=1400&q=80",
  },
  {
    n: "02",
    title: "Digital Commerce",
    body: "Native storefronts, social commerce, and conversion infrastructure.",
    img: "https://images.unsplash.com/photo-1483985988355-763728e1935b?auto=format&fit=crop&w=1400&q=80",
  },
  {
    n: "03",
    title: "Sustainability",
    body: "Materials, traceability, and circular systems engineered to scale.",
    img: "https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=1400&q=80",
  },
  {
    n: "04",
    title: "Creator Economy",
    body: "Tools for designers, stylists, and creator-led commerce verticals.",
    img: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?auto=format&fit=crop&w=1400&q=80",
  },
  {
    n: "05",
    title: "Retail Innovation",
    body: "Reimagined showroom, wholesale, and physical retail operating systems.",
    img: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=1400&q=80",
  },
  {
    n: "06",
    title: "Supply Chain Technology",
    body: "On-demand manufacturing, inventory intelligence, and logistics rails.",
    img: "https://images.unsplash.com/photo-1416339306562-f3d12fefd36f?auto=format&fit=crop&w=1400&q=80",
  },
  {
    n: "07",
    title: "Digital Fashion",
    body: "Virtual garments, 3D pipelines, and the rise of digital-first brands.",
    img: "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?auto=format&fit=crop&w=1400&q=80",
  },
  {
    n: "08",
    title: "Workforce Development",
    body: "Talent pipelines for the next generation of fashion operators and engineers.",
    img: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1400&q=80",
  },
];

export default function FocusAreas() {
  return (
    <section
      id="focus"
      data-testid="focus-section"
      className="relative bg-black text-white border-t border-white/5"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-14 pt-28 md:pt-40 pb-0">
        <div className="grid grid-cols-12 gap-y-12 md:gap-x-16 items-end mb-16 md:mb-20">
          <div className="col-span-12 md:col-span-4">
            <p className="text-xs uppercase tracking-[0.3em] text-white/50">
              §03 — Focus areas
            </p>
          </div>
          <div className="col-span-12 md:col-span-8">
            <motion.h2
              initial={{ y: 20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
            >
              Where we <span className="italic font-light">deploy</span> conviction.
            </motion.h2>
          </div>
        </div>
      </div>

      {/* Architectural grid with 1px borders */}
      <div className="border-t border-white/10">
        <div className="max-w-[1600px] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
          {AREAS.map((a, i) => (
            <motion.a
              key={a.n}
              href="#apply"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 4) * 0.06 }}
              data-testid={`focus-${a.n}`}
              className="group relative overflow-hidden border-b border-r border-white/10 aspect-[4/5] flex flex-col justify-end p-6 md:p-8 cursor-pointer"
            >
              <div className="absolute inset-0">
                <img
                  src={a.img}
                  alt={a.title}
                  loading="lazy"
                  className="w-full h-full object-cover grayscale opacity-30 group-hover:opacity-70 group-hover:scale-[1.05] transition-all duration-[1200ms] ease-out"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-black/10 group-hover:from-black group-hover:via-black/50 transition-colors" />
              </div>

              <div className="relative z-10">
                <div className="flex items-center justify-between mb-6">
                  <span className="font-serif text-sm text-white/50">{a.n}</span>
                  <span className="text-white/40 group-hover:text-white transition-colors text-lg leading-none">↗</span>
                </div>
                <h3 className="font-serif text-2xl md:text-3xl text-white tracking-tight leading-tight">
                  {a.title}
                </h3>
                <p className="mt-3 text-sm text-white/60 font-light leading-relaxed max-h-0 opacity-0 group-hover:max-h-24 group-hover:opacity-100 overflow-hidden transition-all duration-500">
                  {a.body}
                </p>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
